import {COLLECTION_USER} from '../users/constants';
import {COLLECTION_JOURNAL_SESSIONS} from './constants';

export function getJournalSessionsCollectionPath(uid: string): string {
  return `${COLLECTION_USER}/${uid}/${COLLECTION_JOURNAL_SESSIONS}`;
}
